const encodeHtml = (value) => btoa(unescape(encodeURIComponent(value || '')));

export const getEmbeddedEmailCss = (html) => {
  const document = new DOMParser().parseFromString(html || '', 'text/html');
  return Array.from(document.querySelectorAll('style'))
    .filter((style) => !style.disabled && (!style.type || style.type === 'text/css'))
    .map((style) => style.media ? `@media ${style.media} {${style.textContent}}` : style.textContent)
    .join('\n').trim();
};

// Keep editable source separate from the complete, email-client-ready document.
export const compileEmailTemplate = async (stripoApi, html, css, compileSource) => {
  const embeddedCss = getEmbeddedEmailCss(html);
  let compiledHtml;
  let ampHtml;

  if (embeddedCss) {
    // Stripo's session compiler inlines the separate CSS but only copies <style>
    // blocks into the head. Its inline resets then override custom block spacing.
    // Compile the original source with both stylesheets in the inlining input.
    const result = await compileSource({ html, css: `${css || ''}\n${embeddedCss}`, minimize: true });
    compiledHtml = result.html;
    ampHtml = result.ampHtml;
  } else {
    const result = await new Promise((resolve, reject) => stripoApi.compileEmail((error, html, ampHtml) => {
      if (Array.isArray(error) ? error.length > 0 : !!error) {
        reject(new Error('Unable to compile the email template. Please try again.'));
        return;
      }
      resolve({ html, ampHtml });
    }, true));
    compiledHtml = result.html;
    ampHtml = result.ampHtml;
  }

  if (!compiledHtml?.trim()) {
    throw new Error('Unable to compile the email template. Please try again.');
  }

  return {
      body: compiledHtml,
      ampHtml,
      stripoBody: {
        templateHtml: encodeHtml(html),
        templateCss: encodeHtml(css),
        emailHtml: encodeHtml(compiledHtml),
      },
  };
};

export const createEmailTemplateFormData = (values, { body, stripoBody }) => {
  const formData = new FormData();
  formData.append('description', values.description || '');
  formData.append('subject', values.subject || '');
  formData.append('templateType', 'stripo');
  formData.append('preheader', values.preheader || '');
  formData.append('type', values.type || '');
  // Pass the compilation result directly; Formik state may still hold the previous body.
  formData.append('body', body);
  formData.append('blockids', JSON.stringify([]));
  formData.append('uploadedattachments', []);
  Object.entries(stripoBody).forEach(([key, value]) => {
    formData.append(key, new Blob([value], { type: 'text/plain' }));
  });
  formData.append('status', 'active');
  (values.attachments || []).forEach((attachment) => formData.append('file', attachment));
  return formData;
};
